var exports = {
  "e": "CollapseButton__vuXdCD",
};

module.exports = exports;
